import { CountryPath } from "src/entities/CountryPath";
import { CreditInfo } from "src/entities/v3/AuthMeResponse";

export const getCredit = (
  credits: CreditInfo[] | undefined,
  country: CountryPath
): number => {
  const credit = credits?.find((value) => value.country === country);
  return credit ? credit.quantity : 0;
};
